






















import { defineComponent } from "@vue/composition-api"

import SiteHeader from "@/components/SiteHeader.vue"
import SystemNotifications from "@/components/SystemNotifications.vue"

import { getAvailableLocales, momentInstance } from "@/plugins/i18n"

// sp判定
import isMobile from "ismobilejs"

export default defineComponent({
  components: { SiteHeader, SystemNotifications },
  setup: () => {
    return {
      locales: getAvailableLocales(),
      isMobile,
    }
  },
  methods: {
    // @ts-ignore
    onSelectLocale: (nextLocale: string) => momentInstance.locale(nextLocale),
  },
})
